import requestConsulting from "@/api/requestConsulting";
import login from "@/api/login";
import statics from "@/api/statics"; 
import product from "@/api/product";
import paymentLink from "@/api/paymentLink";
import Payment from "@/api/payment";
import Lesson from "@/api/lesson";
import ProductLesson from "@/api/productLesson";
import ProductLessonDiscount from "@/api/productLessonDiscount";
import ProductLessonOption from "@/api/productLessonOption";
import LoginAccessCode from "@/api/loginAccessCode";
import LessonContentUnlockCode from "@/api/lessonContentUnlockCode";
import PaymentNotice from "@/api/PaymentNotice";
import OfflineClassApplication from "@/api/OfflineClassApplication";
import AccessCodePaymentAudit from "@/api/AccessCodePaymentAudit";
import Notice from "@/api/Notice";
import lessonAccess from "@/api/lessonAccess";
import file from "@/api/file";
import LearningSession from "@/api/LearningSession";
import noticeModal from "@/api/noticeModal";
import teamLeaderAccessCode from "@/api/teamLeaderAccessCode";

export default {
  statics: statics,
  requestConsulting: requestConsulting,
  login : login,
  product: product,
  paymentLink: paymentLink,
  payment: Payment,
  lesson: Lesson,
  productLesson: ProductLesson,
  productLessonDiscount: ProductLessonDiscount,
  productLessonOption: ProductLessonOption,
  loginAccessCode: LoginAccessCode,
  lessonContentUnlockCode: LessonContentUnlockCode,
  paymentNotice: PaymentNotice,
  offlineClassApplication: OfflineClassApplication,
  accessCodePaymentAudit: AccessCodePaymentAudit,
  lessonAccesses: lessonAccess,
  notice: Notice,
  file: file,
  learningSession: LearningSession,
  noticeModal: noticeModal,
  teamLeaderAccessCode: teamLeaderAccessCode,
}